<template>

  <div class="table-wrapper">

    <a-button type="primary" v-if="modeDetail" style="margin-bottom: 20px;" @click="show_all_exhibitors()">Show all exhibitors</a-button>

    <a-row :gutter="16" v-if="!modeDetail">
      <a-col :xs="24" :md="12" :lg="6">
        <a-input-search
          placeholder="Search by Stand name or Booth number"
          @search="on_search($event)"
        />
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-input-search
          placeholder="Search by Description (key word)"
          @search="on_search_description($event)"
        />
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-tree-select
          v-model:value="valueCategories"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="Select categories"
          allow-clear
          multiple
          :tree-data="treeDataCategories"
        >
          <template #title="{ value: val, title }">
            <b v-if="val === 'parent 1-1'" style="color: #08c">{{ val }}</b>
            <template v-else>{{ title }}</template>
          </template>
        </a-tree-select>
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-tree-select
          v-model:value="valueSegments"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="Select applications"
          allow-clear
          multiple
          :tree-data="treeDataSegments"
          >
          <template #title="{ value: val, title }">
            <b v-if="val === 'parent 1-1'" style="color: #08c">{{ val }}</b>
            <template v-else>{{ title }}</template>
          </template>
        </a-tree-select>
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-select
          v-model:value="valueCountry"
          show-search
          placeholder="Select a country"
          style="width: 100%"
          :options="countryList"
          optionFilterProp="label"
          mode="multiple"
          @change="handleChangeCountry"
        ></a-select>
      </a-col>

    <a-col :xs="24" :md="12" :lg="6">
        <a-checkbox v-model:checked="isHighlightsFilterChecked">With Highlights</a-checkbox>
    </a-col>

    <a-col :xs="{ span: 24, offset: 0 }" :md="{ span: 12, offset: 12 }" :lg="{ span: 6, offset: 0 }">
        <a-checkbox v-model:checked="isNewlaunchesFilterChecked">With New Launches</a-checkbox>
    </a-col>

  </a-row>

    

    <!-- <a-input v-model:value="search_companyname" placeholder="Basic usage" @click="on_search($event)" /> -->

    <!-- <input type="text" v-model="search_companyname" @click="on_search"> -->

    <a-table :columns="columns" :data-source="dataSource" :sticky="true" :expandRowByClick="true" :bordered="true" @expand="get_additionnal_data" :defaultExpandedRowKeys="defaultExpendedRowExh">

      <template #expandedRowRender="{ record }">

        <p><label for="company_name">Company name:</label> {{ record.company_name }}</p>

        <p><span class="description" v-if="record.description_fr">{{ record.description_fr }}</span></p>
        <a-divider dashed v-if="record.description_fr" />

        <p><span class="description" v-if="record.description_en">{{ record.description_en }}</span></p>
        <a-divider dashed v-if="record.description_en" />

        <p><span class="description" v-if="record.description_de">{{ record.description_de }}</span></p>
        <a-divider dashed v-if="record.description_de" />

        
        <p><label for="phone">Phone:</label> {{ record.cat_phone }}</p>
        <p><label for="mail">Email:</label> {{ record.cat_email }}</p>
        <p><label for="website">Website:</label> {{ record.cat_website }}</p>
        <p><label for="address">Address:</label> {{ record.cat_address1 }}<span v-if="record.cat_address2">, {{ record.cat_address2 }}</span><span v-if="record.cat_address3">, {{ record.cat_address3 }}</span><span v-if="record.cat_postal_code"> - {{ record.cat_postal_code }}</span><span v-if="record.cat_city"> - {{ record.cat_city }}</span><span v-if="record.cat_country_state"> - {{ record.cat_country_state }}</span><span v-if="record.cat_country"> - {{ record.cat_country }}</span></p>



        <div v-if="matrix_by_key[record.key]">
          

          <div class="container-2-col">
            <div class="col-left">


              <div v-if="matrix_by_key[record.key]['highlights'].length">
                
                <hr>
                <p><strong>Highlights</strong></p>

                <div v-for="item in matrix_by_key[record.key]['highlights']" :key="item" style="padding: 10px 0px 10px 10px;">
                  <p>
                    <span v-if="item.brand"><strong>{{item.brand}}</strong></span><br>
                  <span v-if="item.short_description">{{item.short_description}}</span><br>
                  <span v-if="item.short_description"><a :href="'https://www.indexnonwovens.com/en/page/new-launches-innovations-1427?highlight_id=' + item.id + '#highlights'" target="_blank">View more details</a></span>
                  </p>
                </div>

              </div>


            </div> <!-- col-left -->
            <div class="col-right">


              <div v-if="matrix_by_key[record.key]['newlaunches'].length">
                
                <hr>
                <p><strong>New launches</strong></p>

                <div v-for="item in matrix_by_key[record.key]['newlaunches']" :key="item" style="padding: 10px 0px 10px 10px;">
                  <p>
                    <span v-if="item.brand"><strong>{{item.brand}}</strong></span><br>
                  <span v-if="item.short_description">{{item.short_description}}</span><br>
                  <span v-if="item.short_description"><a :href="'https://www.indexnonwovens.com/en/page/new-launches-innovations-1427?newlaunch_id=' + item.id + '#newlaunches'" target="_blank">View more details</a></span>
                  </p>
                </div>

              </div>


            </div> <!-- col-right -->
          </div>


          <div v-if="matrix_by_key[record.key]['selected_categories'].length">
            <hr>
            <p><strong>Categories</strong></p>
            <p>
              <ul>
                <li v-for="category in matrix_by_key[record.key].selected_categories" :key="category">{{category.title}}
                  <ul v-if="category.child.length">
                    <li v-for="category_lvl2 in category.child" :key="category_lvl2.id">
                      {{category_lvl2.title}}
                        <ul v-if="category_lvl2.child.length">
                        <li v-for="category_lvl3 in category_lvl2.child" :key="category_lvl3.id">
                          {{category_lvl3.title}}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </p>
          </div>


          <div v-if="matrix_by_key[record.key]['selected_segments'].length">
            <hr>
            <p><strong>Applications</strong></p>

            <ul>
              <li v-for="item in matrix_by_key[record.key]['selected_segments']" :key="item">{{item.title}}
                <ul>
                  <li v-for="subitem in item['children']" :key="subitem">
                    {{subitem.title}}
                      <ul>
                      <li v-for="subsubitem in subitem['children']" :key="subsubitem">
                        {{subsubitem.title}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>

          </div>
          
        </div>

      </template>
    </a-table>
  </div>
</template>

<script>



// var edition_id = 20912; // INDEX 2023
var edition_id = 13844; // INDEX 2020 - ne pas oublier ajouter colonne stand


const axios = require('axios').default;
var _ = require('lodash');


import { ref } from 'vue';


export default {
  name: 'App',
  components: {
  },
  methods: {
    perform_filter() {

      this.dataSource = this.dataSourceOriginal;

      // filter by selected categories
      var selected_categories = this.selected_categories;
      if (!_.isEmpty(selected_categories)) {
        this.dataSource = _.filter(this.dataSource, function(o) { return !(_.isEmpty(_.intersection(o.selected_categories_list, selected_categories))); });
      }

      // filter by selected segments
      var selected_segments = this.selected_segments;
      if (!_.isEmpty(selected_segments)) {
        this.dataSource = _.filter(this.dataSource, function(o) { return !(_.isEmpty(_.intersection(o.selected_segments_list, selected_segments))); });
      }

      // filter by selected highlights
      if (this.selected_is_highlights == true) {
        this.dataSource = _.filter(this.dataSource, function(o) { 
          return o.is_highlights == true;
        });
      }

      // filter by newlaunches
      if (this.selected_is_newlaunches == true) {
        this.dataSource = _.filter(this.dataSource, function(o) { 
          return o.is_newlaunches == true;
        });
      }

      // filter by countries
      var selected_countries = this.selected_countries;
      if (!_.isEmpty(selected_countries)) {
        this.dataSource = _.filter(this.dataSource, function(o) { 
          return selected_countries.includes(o.cat_country_code);
        });
      }

      // filter by description
      var selected_description = this.selected_description.toLowerCase();
      if (!_.isEmpty(selected_description)) {
        this.dataSource = _.filter(this.dataSource, function(o) { 
          var description_en = '';
          var description_de = '';
          var description_fr = '';

          if (o.description_en) {
            description_en = o.description_en.toLowerCase();
          }
          if (o.description_de) {
            description_de = o.description_de.toLowerCase();
          }
          if (o.description_fr) {
            description_fr = o.description_fr.toLowerCase();
          }
          return description_en.includes(selected_description) || description_fr.includes(selected_description) || description_de.includes(selected_description)   
        });
      }

      // filter by search
      var selected_search = this.selected_search;
      if (!_.isEmpty(selected_search)) {
        selected_search = selected_search.toLowerCase();

        this.dataSource = _.filter(this.dataSource, function(o) { 

          if (o.exh_booth) {
            return o.cat_banner.toLowerCase().includes(selected_search) || o.exh_booth.toLowerCase().includes(selected_search); 
          } else {
            return o.cat_banner.toLowerCase().includes(selected_search); 
          }

        });

      }
   },
    get_additionnal_data(expended, record) {
      if(expended == true) {
        // axios.get("https://catalog-admin.palexpo.ch/index/exhibitors_matrix_formatted_for_website/" + record.key + '/').then((response) => {
        axios.get("https://catalog-admin.palexpo.ch/index/exhibitors_matrix_formatted_for_website/" + record.key + '/').then((response) => {
          this.matrix_by_key[record.key] = response.data;
        });
      }
    },
    get_exhibitors(exh_id) {

      axios.get("https://catalog-admin.palexpo.ch/index/segments_categories_formatted_for_website/").then((response) => {
        // this.dataSourceOriginal = response.data.exhibitor_list;
        // this.dataSource = this.dataSourceOriginal;

        this.categoryTree = response.data.category_tree;
        this.treeDataCategories = ref(response.data.category_tree);
        this.treeDataSegments = ref(response.data.segment_tree);
        this.countryList = response.data.country_list;
      });
  

      // axios.get("https://catalog-admin.palexpo.ch/index/exhibitors_for_website/" + edition_id).then((response) => {
      axios.get("https://catalog-admin.palexpo.ch/index/exhibitors_for_website/" + edition_id).then((response) => {
        this.dataSourceOriginal = response.data.exhibitor_list;
        
        if (exh_id) {
          this.dataSource = _.filter(this.dataSourceOriginal, function(o) { return exh_id == o.key; });
          this.modeDetail = true;
          this.get_additionnal_data(true, { key: exh_id } )
        } else {
          this.dataSource = this.dataSourceOriginal;
        }

        // this.categoryTree = response.data.category_tree;
        // this.treeDataCategories = ref(response.data.category_tree);
        // this.treeDataSegments = ref(response.data.segment_tree);
        // this.countryList = response.data.country_list;
      });
    },
    on_search(selected_search) {
      this.selected_search = selected_search;
      this.perform_filter();            
    },
    on_search_description(selected_description) {
      this.selected_description = selected_description;
      this.perform_filter();      
    },
    handleChangeCountry(selected_countries) {
      this.selected_countries = selected_countries;
      this.perform_filter();
    },
    show_all_exhibitors() {
      this.dataSource = this.dataSourceOriginal;
      this.modeDetail = false;
      this.defaultExpendedRowExh = [];
    },
  },
  mounted() {

    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);

    // get highlight param
    let exh_id = parseInt(params.get("exh_id")); // returns a int
    this.defaultExpendedRowExh.push(exh_id);


    this.get_exhibitors(exh_id);
  },
  watch: {
    
    valueCategories(selected_categories) {
      this.selected_categories = selected_categories;
      this.perform_filter();
    },
    valueSegments(selected_segments) {
      this.selected_segments = selected_segments;
      this.perform_filter();
    },


    isHighlightsFilterChecked(value) {
      this.selected_is_highlights = value;
      this.perform_filter();
    },


    isNewlaunchesFilterChecked(value) {
      this.selected_is_newlaunches = value;
      this.perform_filter();
    },


  },
  data: function () {
    return {
      matrix_by_key: {},
      dataSource: [],
      dataSourceOriginal: [],
      categoryTree: [],
      countryList: [],
      defaultExpendedRowExh: [],
      columns: [
        {
          title: 'Stand name',
          dataIndex: "cat_banner",
          key: "cat_banner",
          fixed: true,
        },
        {
          title: 'Country',
          dataIndex: "cat_country",
          key: "cat_country",
          width: "300px",
          responsive: ['md'],
        },
       {
         title: 'Stand No.',
         dataIndex: "exh_booth",
         key: "exh_booth",
         width: "120px",
         responsive: ['md'],
       },
      ],
      valueCategories: ref([]),
      treeDataCategories: ref([]),
      valueSegments: ref([]),
      treeDataSegments: ref([]),
      valueCountry: ref(undefined),
      isHighlightsFilterChecked: ref(false),
      isNewlaunchesFilterChecked: ref(false),

      selected_categories: [],
      selected_segments: [],
      selected_is_highlights: false,
      selected_is_newlaunches: false,
      selected_countries: [],
      selected_company_name: '',
      selected_description: '',

    }
  },
  setup() {
    // const value = ref([]);
    // const treeDataCategories = ref([{
    //   title: 'parent 1',
    //   value: 'parent 1',
    //   children: [{
    //     title: 'parent 1-0',
    //     value: 'parent 1-0',
    //     children: [{
    //       title: 'my leaf',
    //       value: 'leaf1',
    //     }, {
    //       title: 'your leaf',
    //       value: 'leaf2',
    //     }],
    //   }, {
    //     title: 'parent 1-1',
    //     value: 'parent 1-1',
    //   }],
    // }]);
    // watch(value, () => {
    //   console.log('select', value.value);
    // });
    // return {
    //   value,
    //   treeDataCategories,
    // };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  font-size: 32px;
}

#app .ant-table {
  font-size: 18px;
}

#app .description {
  font-size: 18px;
}

#app .ant-table-row-level-0 {
  cursor: pointer;
}

#app .table-wrapper {
  max-width: 1160px;
  margin: auto;
}

#app .ant-table-expanded-row-level-1 .ant-table-cell {
  border-bottom: 2px solid #cecece;
  /* border-top: 2px solid black; */
  padding-left: 60px;
}

#app .matrix_table table, #app .matrix_table th, #app .matrix_table td {
  border: 1px solid #000000;
}

#app .matrix_table td {
  padding: 10px;
}

#app .ant-row .ant-col > span, #app .ant-row .ant-col > div {
  vertical-align: bottom;
  margin-bottom: 20px;
}

#app label {
  font-weight: bold;
}

#app .ant-checkbox-wrapper {
  display: flex !important;
  padding: 5px;
}

#app .container-2-col {
  display: flex;
}

@media (max-width: 800px) { 
  #app .container-2-col {
    display: block;
  }
}


</style>
